import { BorderGridContainer, GridBox, HeroBanner } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';

import { PAGE_TITLE_TEMPLATE } from '../../../ahm-constants/ui';
import { PerksContainer, StyledPerkTile } from './styles';
import buildCtaProps from '../../../cms/utils/perks/build-cta-props';
import Head from '../../../../utils/head';
import imageUrlBuilder from '../../../cms/utils/image-url-builder';
// @ts-expect-error - Automatic, Please fix when editing this file
import Perk from '../../../types/sanity';

type PerksListingProps = {
  perks: Perk[];
};

const PerksListing = ({ perks = [] }: PerksListingProps) => {
  const [featuredPerk, ...perksWithoutFeatured] = perks;
  return (
    <>
      <Head titleTemplate={PAGE_TITLE_TEMPLATE}>
        <title>ahm Perks and Member Offers</title>
        <meta
          name="description"
          content="Want more bang for your buck? Health members get access to discounts on other insurance like Travel & Car, plus offers on glasses, movie tickets, and more."
        />
      </Head>
      <HeroBanner
        cta={{ title: buildCtaProps(featuredPerk)?.ctaText, to: buildCtaProps(featuredPerk)?.ctaUrl }}
        image={{
          alt: featuredPerk?.imageObject?.caption,
          // @ts-expect-error - Automatic, Please fix when editing this file
          src: imageUrlBuilder(featuredPerk?.imageObject?.image).width(undefined).height(116).url(),
        }}
        title={featuredPerk?.name}
        subtitle={featuredPerk?.slogan}
        hasCTAIcon={false}
        isFeaturedOffer
      />

      <BorderGridContainer hideBorderTop>
        <GridBox padding="0">
          <PerksContainer>
            {map(
              (perk) => (
                <StyledPerkTile
                  cta={{ title: buildCtaProps(perk)?.ctaText, to: buildCtaProps(perk)?.ctaUrl }}
                  logo={{
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    src: imageUrlBuilder(perk?.offeredBy?.logo).width(undefined).height(40).url(),
                  }}
                  image={{
                    alt: perk?.imageObject?.caption,
                    // @ts-expect-error - Automatic, Please fix when editing this file
                    src: imageUrlBuilder(perk?.imageObject?.image).width(undefined).height(116).url(),
                  }}
                  key={perk?.name}
                  name={perk?.name}
                />
              ),
              perksWithoutFeatured,
            )}
          </PerksContainer>
        </GridBox>
      </BorderGridContainer>
    </>
  );
};

export default PerksListing;
